import { css } from "@emotion/react";

const Loading = () => {
  return <div css={rootStyle}>Loading</div>;
};

const rootStyle = css`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  align-items: center;
  justify-content: center;
`;

export default Loading;
